
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BlogNotFound: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 text-center">
      <h1 className="text-2xl font-bold mb-4">Beitrag nicht gefunden</h1>
      <p className="mb-6">Der gesuchte Beitrag wurde leider nicht gefunden.</p>
      <Link 
        to="/blog" 
        className="inline-flex items-center bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-700"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Zurück zur Blog-Übersicht
      </Link>
    </div>
  );
};

export default BlogNotFound;
